// eslint-disable-next-line
import jwt_decode from "jwt-decode"

const isTokenExpired = (exp) => {
  // Verificar que el token no haya expirado
  const ahora = Math.floor(Date.now() / 1000)
  if (exp < ahora) {
    console.log("El token ha expirado")
    return true
  }
  return false
}

export const getUserRoles = (token) => {
  const decoded = jwt_decode(token)
  return decoded ? decoded.applicationData?.permissionData?.appRoles : []
}
const application = "CGI"
const roles = [
  "CGI.Admin",
  "CGI.CustomerSupport",
  "CGI.CommercialAgent",
  "CGI.ContentManagementRW",
  "CGI.LegalCommOperator",
  "CGI.MeAppMaintainer",
]

export const validate = (token) => {
  const userAuthentication = {
    isValidRole: false,
    isValidOrgAppAccess: false,
    isValidUserAppAccess: false,
    isValidApplication: false,
    isExpired: true,
  }

  const decoded = jwt_decode(token)

  if (decoded) {
    if (!isTokenExpired(decoded.exp)) userAuthentication.isExpired = false
    if (decoded.applicationData?.applicationCode === application)
      userAuthentication.isValidApplication = true

    const appRoles = decoded.applicationData?.permissionData?.appRoles

    if (appRoles && appRoles.length > 0) {
      appRoles.forEach((element) => {
        if (roles.includes(element)) userAuthentication.isValidRole = true
      })
    }

    if (
      decoded.applicationData?.permissionData?.orgAppAccessStatusCode ===
      "GRANTED"
    )
      userAuthentication.isValidOrgAppAccess = true

    if (
      decoded.applicationData?.permissionData?.userAppAccessStatusCode ===
      "GRANTED"
    )
      userAuthentication.isValidUserAppAccess = true
  }

  return userAuthentication
}

export const getTokenValidateDate = (token1, token2) => {
  try {
    // Verificar la firma y obtener los datos decodificados
    const decoded1 = jwt_decode(token1)
    const decoded2 = jwt_decode(token2)
    if (decoded1.exp <= decoded2.exp) {
      return token2
    } else if (decoded1.exp > decoded2.exp) {
      return token1
    }
  } catch (error) {
    // Ocurrió un error al validar el token
    console.error("Error al validar el token:", error.message)
    return null
  }
}
